/*
 * @Author: Teemo Ding
 * @Date: 2021-04-20 15:40:42
 * @LastEditTime: 2021-07-06 11:14:21
 * @LastEditors: Teemo Ding
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/ThumbnailImage/index.tsx
 */

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import { useDispatch } from 'react-redux';
import DragNDropColumns from 'src/components/DragNDropColumns';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { EnumLinkType } from '@/src/types/common/linkType';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getThumbnailImage,
  onCollapseOpen,
  onErrorChange,
  onThumbnailImageOnChange,
  onThumbnailImageOnSort,
} from '../slice';

import { validateThumbnailImage } from '../tools';

import { getI18nFromGeneral } from '@/src/tools/tools';
import styles from './style.module.less';

const ThumbnailImage = (props) => {
  const { data, specificError = {}, isOnPrimaryLanguage, disabled } = props;
  const { linkModules = [] } = data;

  const _d = useDispatch();
  const renderContent = (data, index) => {
    const { draggableId, title, subtitle, linkImage } = data || {};
    const imageErrorArray = specificError[`${draggableId}_imageError`] || [];
    return (
      <Section key={draggableId} className={styles.section}>
        <DraggableImageDisplay
          title={title}
          subtitle={subtitle}
          imgOnChange={(img) =>
            handleOnChange(index, {
              linkImage: img,
              linkType: EnumLinkType.None,
              draggableId,
            })
          }
          linkImage={linkImage}
          error={imageErrorArray}
          disabled={disabled}
        />
      </Section>
    );
  };

  const handleOnChange = (index, data) => {
    _d(onThumbnailImageOnChange({ index, data }));
  };

  const onThumbnailImageSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    _d(onThumbnailImageOnSort({ from: newIndex, to: oldIndex }));
  };

  return linkModules.length > 0 ? (
    <div>
      {isOnPrimaryLanguage ? (
        <DragNDropColumns
          hideTitle
          childGenerate={renderContent}
          data={linkModules || []}
          droppableId={'thumbnailImage'}
          onSort={onThumbnailImageSort}
          hideAdd
          onAdd={() => {
            console.log('onAdd');
          }}
          addText=''
          hideDrag={disabled}
        />
      ) : (
        <div>
          {linkModules.map((data, index) => renderContent(data, index))}
        </div>
      )}
    </div>
  ) : (
    ''
  );
};

export default ErrorProcessingHOC(ThumbnailImage, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.thumbnailImage,
  getContent: getThumbnailImage,
  title: getI18nFromGeneral('general.hOCTitle.variantThumbnailImage'),
  validation: validateThumbnailImage,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
